export function getNumberPlaces(num) {
	return Math.pow(10, Math.floor(Math.log10(num)));
}

export function validateInputValue(value, min, max) {
	if (value < min) return min;
	if (value > max) return max;

	return value;
}

export function getIndexOfArraysDiff(array1, array2) {
	if (JSON.stringify(array1) !== JSON.stringify(array2)) {
		if (array1[0] !== array2[0]) return 0;
		if (array1[1] !== array2[1]) return 1;
	}

	return null;
}
